import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import BackMethods from "../../back_component/BackMethods";

export default function ChangePasswordPage() {
    const { userId } = useParams();
    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();

    const [newPassword, setNewPassword] = useState("");
    const [mustChangePassword, setMustChangePassword] = useState(true);
    const [message, setMessage] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const res = await backEnd_request.post(
                `/admin/UsersManagement/${userId}/change-password`,
                {
                    newPassword,
                    mustChangePassword
                }
            );

            setMessage("✅ تم تغيير كلمة المرور بنجاح");

            setTimeout(() => {
                navigate("/admin/users-management", {
                    state: { successMessage: "✅ تم تغيير كلمة المرور" }
                });
            }, 1500);

        } catch (error) {
            console.log(error.response?.data);
            setMessage("❌ حدث خطأ أثناء تغيير كلمة المرور");
        }
    };

    return (
        <div className="container py-5">
            <div className="card p-4 shadow" style={{ maxWidth: "500px", margin: "0 auto" }}>
                <h4 className="text-center mb-3 text-primary">تغيير كلمة المرور</h4>

                {message && <div className="alert alert-info text-center">{message}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label className="form-label">كلمة المرور الجديدة</label>
                        <input
                            className="form-control"
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-check mb-3">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            checked={mustChangePassword}
                            onChange={() => setMustChangePassword(!mustChangePassword)}
                        />
                        <label className="form-check-label">
                            يجب تغيير كلمة المرور عند الدخول
                        </label>
                    </div>

                    <button className="btn btn-primary w-100">تغيير</button>
                </form>

                <button
                    className="btn btn-secondary w-100 mt-2"
                    onClick={() => navigate("/admin/users-management")}
                >
                    رجوع
                </button>
            </div>
        </div>
    );
}
